import { LoginForm } from '@trafiflow/shared-ui'
import { useAuth } from '@trafiflow/shared-ui'

export default function Login() {
  const { login, completeNewPassword } = useAuth()

  return (
    <LoginForm
      onLogin={login}
      onCompleteNewPassword={completeNewPassword}
      appName="NextStore Customer Portal"
    />
  )
}











